import { render, staticRenderFns } from "./SingleReturnMoveModal.vue?vue&type=template&id=26a35f24&"
import script from "./SingleReturnMoveModal.vue?vue&type=script&lang=js&"
export * from "./SingleReturnMoveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SingleReturnMoveModal.vue"
export default component.exports